// import Vue from "vue";
// import VueI18n from "vue-i18n";
import { has } from "lodash";

// Vue.use(VueI18n);

export default {
    data() {
        return {};
    },
    computed: {
        _locale() {
            return this.$root.setting
                ? this.$root.setting.locale.replace("_", "-")
                : "en-US";
        },
        _currency() {
            let currency = "";

            if (has(this.$store.getters["setting"], "currency_symbol")) {
                currency = this.$store.getters["setting"].currency_symbol;
            }

            return this.$store.getters["currency"] || currency;
        }
    },
    methods: {
        _toCurrency(value, cents = true) {
            if (!value && value != 0 && value != "0") return "";

            let val = Number(val);
            val = (value / 1).toFixed(cents ? 2 : 0);

            let number = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            if (val < 0) {
                return "(" + this._currency + number.replace("-", "") + ")";
            } else {
                return this._currency + number;
            }
        },
        _toNumber(value, decimal = 0, withComma = true) {
            if (!value && value != 0 && value != "0") return "";

            let val = Number(val);
            val = (value / 1).toFixed(decimal);
            if (withComma) {
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return val.toString();
            }
        }
    }
};
